export default __webpack_public_path__ + "files/a4fbe929af4c8c04c26c863e1c96fef6.jpg";